import { Alert, Card, Col, Modal, Row } from "antd";
import CopyInput from "components/atoms/CopyInput";
import { useEffect, useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

// Shows a freshly created key exactly once. The plaintext never comes back from the server again.
const ApiKeySecretModal = ({ show, title, apiKey, onClose }) => {
    const [isVisible, setIsVisible] = useState(show);

    useEffect(() => {
        setIsVisible(show);
    }, [show]);

    const close = () => {
        setIsVisible(false);
    };

    return (
        <Modal
            closable={false}
            maskClosable={false}
            title={<Alert title={title || "API key created successfully"} type="success" showIcon />}
            centered
            open={isVisible}
            onOk={close}
            onCancel={close}
            afterClose={onClose}
            destroyOnHidden={true}
            width={1000}
            okText="I have copied the key"
            cancelButtonProps={{ style: { display: "none" } }}
            className="model-alert-title"
            data-testid={CypressTestIds.API_KEY_SECRET_MODAL}
        >
            <Alert className="mb-4" type="warning" showIcon title="Copy your API key now. For security reasons it will not be shown again." />
            <Row gutter={16}>
                <Col span={12}>
                    <Card title="Name" variant="borderless" size="small">
                        {apiKey.name}
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Key ID" variant="borderless" size="small">
                        <CopyInput readOnly={true} value={apiKey.apiKeyId} copyToolTip="Copy Key ID"></CopyInput>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Card title="API Key" variant="borderless" size="small">
                        <CopyInput readOnly={true} value={apiKey.apiKey} copyToolTip="Copy API Key" className="font-mono" data-testid={CypressTestIds.API_KEY_SECRET_MODAL_COPY_INPUT}></CopyInput>
                    </Card>
                </Col>
            </Row>
        </Modal>
    );
};

export default ApiKeySecretModal;
